import { FC } from "react";

// * Props
import ConfirmationPopupProps from "./ConfirmationPopup.interface";

// * Components
import { Button } from "../Button";
import { ButtonGroup } from "../ButtonGroup";
import { Popup } from "../Popup";
import PopupStructure from "../PopupStructure";
import PopupTitleDangerous from "../PopupTitleDangerous";

// * styles
import styles from "./ConfirmationPopup.module.css";

const ConfirmationPopup: FC<ConfirmationPopupProps> = ({
  action,
  label,
  onClose,
  actionButtonLabel,
  closeButtonLabel,
  closeWhenSubmit=true,
  ...popupProps
}) => {
  const handleAction = () => {
    action();
    if (closeWhenSubmit) {
      onClose();
    }
  };

  return (
    <Popup {...popupProps} onClose={onClose}>
      <PopupStructure
        headerComponent={
          <PopupTitleDangerous>
            Предупреждение
          </PopupTitleDangerous>
        }
        contentComponent={
          <div className={styles["confirmation-popup__content"]}>
            {label}
          </div>
        }
        footerComponent={
          <ButtonGroup>
            <Button kind={actionButtonLabel?.kind ?? "secondary"} onClick={handleAction}>{actionButtonLabel?.label ?? "Да"}</Button>
            <Button kind={closeButtonLabel?.kind ?? "primary"} onClick={onClose}>{closeButtonLabel?.label ?? "Нет"}</Button>
          </ButtonGroup>
        }
      />
    </Popup>
  );
};

export default ConfirmationPopup;